var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8252 2.82495H47.8252C46.1683 2.82495 44.8252 4.1681 44.8252 5.82495V21.825C44.8252 23.4818 46.1683 24.825 47.8252 24.825H73.8252C75.482 24.825 76.8252 23.4818 76.8252 21.825V5.82495C76.8252 4.1681 75.482 2.82495 73.8252 2.82495Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8252 34.825H47.8252C46.1683 34.825 44.8252 36.1681 44.8252 37.825V75.825C44.8252 77.4818 46.1683 78.825 47.8252 78.825H73.8252C75.482 78.825 76.8252 77.4818 76.8252 75.825V37.825C76.8252 36.1681 75.482 34.825 73.8252 34.825Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8252 78.825H31.8252C33.482 78.825 34.8252 77.4818 34.8252 75.825V59.825C34.8252 58.1681 33.482 56.825 31.8252 56.825H5.8252C4.16834 56.825 2.8252 58.1681 2.8252 59.825L2.8252 75.825C2.8252 77.4818 4.16834 78.825 5.8252 78.825Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8252 46.825H31.8252C33.482 46.825 34.8252 45.4818 34.8252 43.825L34.8252 5.82495C34.8252 4.1681 33.482 2.82495 31.8252 2.82495H5.8252C4.16834 2.82495 2.8252 4.16809 2.8252 5.82495L2.8252 43.825C2.8252 45.4818 4.16834 46.825 5.8252 46.825Z",
    stroke: "black",
    strokeWidth: 5.65,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.cf7c25fbcccd9c2b104ff6ead19822d5.svg";
export { ForwardRef as ReactComponent };